<template>
	<span>
		<v-card-title class="headline">Envoyer un groupe aux utilisateurs</v-card-title>
		<v-container>
			<v-form ref="form" v-model="valid" style="position:relative;">
				<div style="display:flex;" v-for="subBot in subBots" :key="`send${subBot._id}`">
					<b-o-input
						:input="{ type: 'date', label: subBot.name, min: today, disabled: disabled(subBot._id) }"
						v-model="dates[subBot._id]"
					/>
					<b-o-input
						v-if="dates[subBot._id]"
						:input="{
							type: 'select',
							label: 'Heure',
							itemText: 'text',
							itemValue: 'value',
							values: [
								'0',
								'1',
								'2',
								'3',
								'4',
								'5',
								'6',
								'7',
								'8',
								'9',
								'10',
								'11',
								'12',
								'13',
								'14',
								'15',
								'16',
								'17',
								'18',
								'19',
								'20',
								'21',
								'22',
								'23',
							].map((text) => ({ text, value: Number(text) })),
							disabled: disabled(subBot._id),
						}"
						v-model="hours[subBot._id]"
					/>
					<b-o-input
						v-if="dates[subBot._id]"
						:input="{
							type: 'select',
							label: 'Minutes',
							itemText: 'text',
							itemValue: 'value',
							values: ['0', '15', '30', '45'].map((text) => ({ text, value: Number(text) })),
							disabled: disabled(subBot._id),
						}"
						v-model="minutes[subBot._id]"
					/>
					<b-o-input
						v-if="dates[subBot._id]"
						:input="{
							label: 'Filtre',
							type: 'text',
							rules: [
								(v) =>
									!v ||
									v
										.trim()
										.split(';')
										.filter((filter) => filter !== '')
										.reduce(
											(valid, filter) =>
												valid &&
												filter
													.trim()
													.split(/!=|=/)
													.filter((filter) => filter !== '').length === 2,
											true,
										) ||
									'Format du filtre = \'key=value;key2!=value\'',
							],
							disabled: disabled(subBot._id),
						}"
						v-model="filters[subBot._id]"
					/>
				</div>
			</v-form>
			<v-btn color="primary" @click="schedule">Programmer l'envoi</v-btn>
		</v-container>
	</span>
</template>
<script>
import BOInput from '../../baseComponents/boInput.vue'
import { SUCCESS, ERROR, CLOSE_MODAL } from '../../variables'
export default {
	components: { BOInput },
	props: ['params', 'schedules'],
	data() {
		return {
			valid: false,
			dates: {},
			hours: {},
			minutes: {},
			filters: {},
		}
	},
	computed: {
		disabled() {
			return (subBotId) => {
				if (this.dates[subBotId]) {
					return new Date().getTime() > new Date(this.dates[subBotId]).getTime()
				}
				return false
			}
		},
		today() {
			return new Date().toISOString()
		},
		subBots() {
			return this.$store.getters.bot.subBots
		},
	},
	methods: {
		schedule() {
			this.$refs.form.resetValidation()
			if (this.valid) {
				// TODO add others fiels
				this.axios
					.put(
						'userLists/' + this.params.id + '/schedule',
						Object.keys(this.dates).reduce((acc, subBot) => {
							acc[subBot] = {
								date: this.dates[subBot],
								hour: this.hours[subBot],
								minutes: this.minutes[subBot],
								filters: this.filters[subBot],
							}
							return acc
						}, {}),
					)
					.then((response) => {
						this.$store.dispatch(SUCCESS, 'enregistrement réussi')
						this.$store.dispatch(CLOSE_MODAL)
					})
					.catch((err) => {
						this.$store.dispatch(ERROR, err)
					})
			} else {
				setTimeout(
					function() {
						this.$refs.form.validate()
					}.bind(this),
					200,
				)
			}
		},
	},
	watch: {
		schedules() {
			if (this.schedules) {
				this.schedules.forEach((schedule, i) => {
					this.$set(this.dates, schedule.subBot, new Date(schedule.date))
					this.$set(this.hours, schedule.subBot, schedule.hour)
					this.$set(this.minutes, schedule.subBot, schedule.minutes)
					this.$set(this.filters, schedule.subBot, schedule.filters)
				})
			}
		},
	},
	mounted() {
		console.log(this.schedules)
		if (this.schedules) {
			this.schedules.forEach((schedule, i) => {
				this.$set(this.dates, schedule.subBot, new Date(schedule.date))
				this.$set(this.hours, schedule.subBot, schedule.hour)
				this.$set(this.minutes, schedule.subBot, schedule.minutes)
				this.$set(this.filters, schedule.subBot, schedule.filters)
			})
		}
	},
}
</script>
<style>
.bo-input .v-picker {
	position: fixed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/sendSubBot.vue